// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

import { MiddlewareResponse } from '../middlewareResponse';

export class SetAgentAvailabilityResponse extends MiddlewareResponse {
    public available: boolean;
    public reason: string;
}